module.exports = __webpack_public_path__ + "static/media/rilee-marks-icon.1a9a92b6.jpg";